import React from 'react'

const NodeText = ({message}) => {
  return (
    <div>
      <p style={{textAlign:"center", fontSize:"16px"}}>{message}</p>
    </div>
  )
}

export default NodeText
